<template>
  <span>
      <slot :id="id">
        <span class="question-id"> Q{{ id }} </span>
      </slot>
  </span>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
/**
 * Displays a question ID for debugging/reference purposes
 * */

export default {
  name: 'QuestionId',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.question-id {
  color: #bbb;
}
</style>
